/**
 * Japan Scissors Header Enhancements
 * Extends Dawn's functionality without breaking it
 */

class JapanScissorsHeader {
    constructor() {
        this.initializePersona();
        this.enhanceSearch();
        this.addJapaneseBadge();
    }

    initializePersona() {
        const options = document.querySelectorAll('.prof-option');
        options.forEach(option => {
            option.addEventListener('click', (e) => {
                e.preventDefault();
                options.forEach(opt => opt.classList.remove('active'));
                option.classList.add('active');

                // Store preference
                localStorage.setItem('japanScissorsPersona', option.dataset.persona);

                // Emit event for other components
                document.dispatchEvent(new CustomEvent('persona:changed', {
                    detail: { persona: option.dataset.persona }
                }));

                // Update body class for CSS targeting
                document.body.className = document.body.className.replace(/persona-\w+/, '');
                document.body.classList.add(`persona-${option.dataset.persona}`);
            });
        });

        // Load saved preference
        const savedPersona = localStorage.getItem('japanScissorsPersona') || 'stylist';
        const savedOption = document.querySelector(`[data-persona="${savedPersona}"]`);
        if (savedOption) {
            savedOption.click();
        }
    }

    enhanceSearch() {
        // Add placeholder enhancement for search
        const searchInputs = document.querySelectorAll('.search__input');
        searchInputs.forEach(input => {
            const placeholders = {
                'en': 'Search by brand, size, or steel type...',
                'fr': 'Rechercher par marque, taille ou type d\'acier...',
                'it': 'Cerca per marca, taglia o tipo di acciaio...'
            };

            const locale = document.documentElement.lang || 'en';
            input.placeholder = placeholders[locale] || placeholders['en'];
        });
    }

    addJapaneseBadge() {
        // Add Japanese badge after logo if not exists
        const logo = document.querySelector('.header__heading-link');
        if (logo && !document.querySelector('.japanese-badge')) {
            const badge = document.createElement('div');
            badge.className = 'japanese-badge';
            badge.innerHTML = `
          <svg class="japanese-badge__flag" viewBox="0 0 20 14" xmlns="http://www.w3.org/2000/svg">
            <rect width="20" height="14" fill="#fff"/>
            <circle cx="10" cy="7" r="4" fill="#D2373C"/>
          </svg>
          <span data-ja-craft>Japanese Craftsmanship</span>
        `;
            logo.parentNode.insertBefore(badge, logo.nextSibling);

            // Update text based on locale
            this.updateJapaneseBadgeText();
        }
    }

    updateJapaneseBadgeText() {
        const badge = document.querySelector('[data-ja-craft]');
        if (!badge) return;

        const texts = {
            'en': 'Japanese Craftsmanship',
            'fr': 'Artisanat Japonais',
            'it': 'Artigianato Giapponese'
        };

        const locale = document.documentElement.lang || 'en';
        badge.textContent = texts[locale] || texts['en'];
    }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
        new JapanScissorsHeader();
    });
} else {
    new JapanScissorsHeader();
}

// Re-initialize on Shopify section reload
document.addEventListener('shopify:section:load', () => {
    new JapanScissorsHeader();
});